import { 
  setSessionFormData, 
  clearSessionFormData, 
  hasFormDataChanged
} from '@shared/utils/storage/sessionFormStorage';

export const cleanFormDataErrors = (formData: any): void => {
  Object.keys(formData).forEach((data) => formData[data].errors.clear());
};

export const cleanStringsObject = (object: any): void => {
  Object.keys(object).forEach((key) => (object[key] = ""));
};

export const is_different_previous_value = (contextData: any, formData: any): boolean => {
  let isUnequal = false;
  
  const comparision_oldValue_nowValue = (key: string): boolean => {
    if (typeof formData[key].value === "object") 
      return contextData[key].value !== formData[key].value.value;
    else return contextData[key] !== formData[key].value;
  };

  Object.keys(formData).forEach((key) => {
    if (comparision_oldValue_nowValue(key)) isUnequal = true;
  });

  return isUnequal;
};

export const fields_changed = (formData: any, accountData: any): boolean => {
  return hasFormDataChanged(formData);
};

export const set_localStorage = (formData: any): void => {
  setSessionFormData(formData);
};

export function clearLocalStorage(): void {
  clearSessionFormData();
}
